import styled from 'styled-components';
import { pxToRem, unit } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
import { TOP_HEADER_HEIGHT } from '../constants';
export const NavigationBar = styled.div `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: ${unit('lg')} 0;
  background-color: ${themeGet('colors.gray.0')};
  width: 100%;
  height: ${pxToRem(TOP_HEADER_HEIGHT)};
  position: sticky;
  top: 0;
  z-index: 1;
`;
